export default "__VITE_ASSET__D2yXv9uL__"